const articleFilter = {
  data: {},
  init() {
    // search param
    if (location.search !== "") {
      let queryParams = new URLSearchParams(window.location.search);
      if (queryParams.has("cat")) {
        let cat = decodeURI(queryParams.get("cat"));

        if (cat !== undefined) {
          document.querySelector(`button[data-term-name="${cat}"]`).classList.add("active");
          this.search(null, document.querySelector(`button[data-term-name="${cat}"]`));
          document.getElementById("filter_top").scrollIntoView({ behavior: "smooth" });
          if (queryParams.has("cat-sub")) {
            let subCat = decodeURI(queryParams.get("cat-sub"));
            if (subCat !== undefined) {
              document.querySelector(`button[data-term-name="${subCat}"]`).classList.add("active");
              this.search(null, document.querySelector(`button[data-term-name="${subCat}"]`));
            }
          }
        }
      }
    }

    $(".article-filter__form :submit, .prev-page, .next-page").click(function (e, target) {
      e.preventDefault();
      articleFilter.search(e, $(this));
    });

    $(".filter-option").click(function (e, target) {
      e.preventDefault();
      let wasActive = $(this).hasClass("active") ? true : false;
      $(".filter-option--sub.active").each(function () {
        $(this).removeClass("active");
      });
      if (!$(this).hasClass("filter-option--sub")) {
        $(".filter-option.active").each(function () {
          $(this).removeClass("active");
        });
      }
      if (!$(this).hasClass("active")) {
        $(this).addClass("active");
      } else {
        $(this).remove("active");
      }

      if (wasActive) {
        $(this).removeClass("active");
      }

      articleFilter.search(e, $(this));
    });
  },
  search(e, target) {
    var page = 1;
    this.data["page"] = page;

    if ($(target).hasClass("prev-page")) {
      page = parseInt($(".current-page").text()) - 1;
      if (page !== 0) {
        this.data["page"] = page;
      } else {
        return false;
      }
    }

    if ($(target).hasClass("next-page")) {
      page = parseInt($(".current-page").text()) + 1;
      if (page <= parseInt($(".total-pages").text())) {
        this.data["page"] = page;
      } else {
        return false;
      }
    }

    //show sub filters
    if (!$(target).hasClass("filter-option--sub") && $(target).hasClass("filter-option") && $(target).hasClass("active")) {
      this.showSubfilter($(target).attr("data-term-id"));
    } else if (!$(target).hasClass("filter-option--sub")) {
      document.querySelectorAll(".filter-options--sub").forEach((el) => {
        el.classList.remove("active");
      });
    }

    articleFilter.data["action"] = "get_articles";
    articleFilter.data["article_cat"] = [];
    articleFilter.data["article_cat_sub"] = [];
    articleFilter.data["search"] = $(".article-filter__form input").val();

    const urlParams = new URLSearchParams();

    let filterOption = $(".filter-option.active:not(.filter-option--sub)");
    $(filterOption).each(function () {
      articleFilter.data[$(filterOption).attr("data-taxonomy")].push($(filterOption).attr("data-term-id"));
      urlParams.set("cat", encodeURI($(filterOption).attr("data-term-name")));
    });

    let filterSubOption = $(".filter-option--sub.active");
    $(filterSubOption).each(function () {
      articleFilter.data[$(filterSubOption).attr("data-taxonomy")].push($(filterSubOption).attr("data-term-id"));
      urlParams.set("cat-sub", encodeURI($(filterSubOption).attr("data-term-name")));
    });

    history.replaceState(null, null, "?" + urlParams.toString());

    $.ajax({
      method: "post",
      url: customData.ajaxURL,
      data: articleFilter.data,
      dataType: "json",
      beforeSend: function () {
        $(".block-content").css("opacity", 0.5);
      },
      success: function (response) {
        $(".block-content").removeAttr("style").html("");
        $.each(response.items, function (i, item) {
          $(".block-content").append(item);
        });
        $(".block-content .item").removeClass("fade-in-top");
        window.lazy.update();
        $(".total-pages").text(response.pages);
        $(".current-page").text(page);
        if (response.pages == 0) {
          $(".pagination").hide();
        } else {
          $(".pagination").show();
        }
      },
    });
  },
  showSubfilter(id) {
    document.querySelectorAll(".filter-options--sub").forEach((el) => {
      el.classList.remove("active");
    });

    if (document.body.contains(document.querySelector(`#filter-option-wrapper-${id}`))) {
      document.querySelector(`#filter-option-wrapper-${id}`).classList.add("active");
    }
  },
};

export { articleFilter };
